import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useHandleNavClickCommunityPage } from "../hooks/useHandleNavClick";

export default function Header() {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const menuList = [
    { name: "Home", link: "/" },
    { name: "Our Community", link: "/our_community" },
    { name: "Projects", link: "/our_community#projects" },
  ];

  const handleNavClick = useHandleNavClickCommunityPage()

  const toggleMobileNav = () => {
    setIsMobileNavOpen((prev) => !prev);
  };

  return (
    <header className="sticky top-0 z-50 py-3 sm:py-4 px-4 xs:px-6 sm:px-8 md:px-12 lg:px-16 xl:px-20 2xl:px-[220px] bg-black text-secondary">
      <div className="container flex items-center justify-between relative max-w-7xl mx-auto">
        <NavLink
          to="/"
          aria-label="Tech Space Home"
          className="flex items-center gap-2 sm:gap-3 focus:outline outline-none shrink-0"
        >
          <img
            src="/images/header-logo.png"
            alt="Tech Space Logo"
            className="w-8 h-8 xs:w-9 xs:h-9 sm:w-10 sm:h-10"
          />
          <span className="font-bold text-sm xs:text-base sm:text-lg text-[#d1453b]">
            Tech Space
          </span>
        </NavLink>

        <nav className="hidden md:flex flex-1 justify-center">
          <ul className="flex items-center gap-6 lg:gap-8 xl:gap-10 2xl:gap-12 font-medium text-sm lg:text-base">
            {menuList.map((data, index) => (
              <li key={index}>
                {data.link.includes('#') ? (
                  <button
                    onClick={() => handleNavClick(data.link)}
                    className="relative group transition-colors duration-200 hover:text-primary"
                  >
                    {data.name}
                    <span className="absolute top-full left-0 h-[2px] w-full bg-primary origin-center scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
                  </button>
                ) : (
                  <NavLink
                    to={data.link}
                    className={({ isActive }) =>
                      `relative group transition-colors duration-200 ${isActive ? "text-primary" : "hover:text-primary"
                      }`
                    }
                  >
                    {data.name}
                    <span className="absolute top-full left-0 h-[2px] w-full bg-primary origin-center scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* Desktop CTA Button */}
        <button
          onClick={() => handleNavClick("/#hireUs")}
          className="px-10 xl:px-16 bg-primary hidden md:block text-secondary rounded-full py-2 hover:opacity-90"
        >
          Hire Us
        </button>

        {/* Mobile Menu Button */}
        <button
          aria-label="Toggle Mobile Nav"
          aria-expanded={isMobileNavOpen}
          onClick={toggleMobileNav}
          className="md:hidden cursor-pointer p-1 hover:opacity-80 transition-opacity shrink-0"
        >
          <img
            src="/images/Hambuger.png"
            alt="Menu"
            className="w-6 h-6 xs:w-7 xs:h-7 sm:w-8 sm:h-8"
          />
        </button>

        {isMobileNavOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 -mx-4 xs:-mx-8 sm:-mx-8   bg-black z-50 text-secondary shadow-lg
            border-t border-gray-800 animate-slide-down"
          >
            <nav className="flex flex-col gap-4 sm:gap-6 py-4 xs:py-5 sm:py-6 px-0">
              {/* Mobile Menu Items */}
              <ul className="flex flex-col gap-3 sm:gap-4 font-medium">
                {menuList.map(({ link, name }, index) => (
                  <li key={index}>
                    {link.includes('#') ? (
                      <button
                        onClick={() => {
                          handleNavClick(link);
                          setIsMobileNavOpen(false);
                        }}
                        className="relative group ml-4 block py-2 transition-colors duration-200 text-base sm:text-lg hover:text-primary text-left w-full"
                      >
                        {name}
                        <span className="absolute top-full left-0 h-[2px] w-1/4 bg-primary origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
                      </button>
                    ) : (
                      <NavLink
                        to={link}
                        onClick={() => setIsMobileNavOpen(false)}
                        className={({ isActive }) =>
                          `relative group ml-4 block py-2 transition-colors duration-200 text-base sm:text-lg ${isActive ? "text-primary" : "hover:text-primary"
                          }`
                        }
                      >
                        {name}
                        <span className="absolute top-full left-0 h-[2px] w-1/4 bg-primary origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
                      </NavLink>
                    )}
                  </li>
                ))}
              </ul>

              <button
                onClick={() => {
                  handleNavClick("/#hireUs");
                  setIsMobileNavOpen(false);
                }}
                className="block mx-8 text-center px-6 sm:px-8 py-2 sm:py-3.5 font-medium text-base sm:text-lg rounded-full text-secondary bg-primary hover:opacity-90 transition-all duration-200 mt-2"
              >
                Hire Us
              </button>
            </nav>
          </div>
        )}

      </div>
    </header>
  );
}